// src/redux/slices/advancedFilterSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/store";

interface AssessmentItem {
  candidate_id: string;
  assessment_id: string;
  assessment_name: string;
  timestamp: string;
}

interface AdvancedFilterState {
  activeTab: "program" | "industry" |"";
  selectedItem: AssessmentItem | null;
  selectedCandidateId: string | null;
  selectedAssessmentId: string | null;
}

const initialState: AdvancedFilterState = {
  activeTab: "program",
  selectedItem: null,
  selectedCandidateId: null,
  selectedAssessmentId: null,
};

const advancedFilterSlice = createSlice({
  name: "advancedFilter",
  initialState,
  reducers: {
    setActiveTab: (state, action: PayloadAction<"program" | "industry" |"">) => {
      state.activeTab = action.payload;
    },
    setSelectedItem: (state, action: PayloadAction<AssessmentItem | null>) => {
      if (action.payload) {
        state.selectedItem = action.payload;
        state.selectedCandidateId = action.payload.candidate_id;
        state.selectedAssessmentId = action.payload.assessment_id;
      } else {
        state.selectedItem = null;
        state.selectedCandidateId = null;
        state.selectedAssessmentId = null;
      }
    },

    resetToProgram: (state, action: PayloadAction<AssessmentItem | null>) => {
      state.activeTab = "program";
      if (action.payload) {
        state.selectedItem = action.payload;
        state.selectedCandidateId = action.payload.candidate_id;
        state.selectedAssessmentId = action.payload.assessment_id;
      } else {
        state.selectedItem = null;
        state.selectedCandidateId = null;
        state.selectedAssessmentId = null;
      }
    },
     resetToIndustry: (state, action: PayloadAction<AssessmentItem | null>) => {
      state.activeTab = "industry";
      if (action.payload) {
        state.selectedItem = action.payload;
        state.selectedCandidateId = action.payload.candidate_id;
        state.selectedAssessmentId = action.payload.assessment_id;
      } else {
        state.selectedItem = null;
        state.selectedCandidateId = null;
        state.selectedAssessmentId = null;
      }
    },
  },
});

export const { setActiveTab, setSelectedItem, resetToProgram,resetToIndustry } =
  advancedFilterSlice.actions;
export default advancedFilterSlice.reducer;
